import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Обрезать строку по графемам, а не по кодовым единицам.
 *
 * `maxLength` у input считает UTF-16-юниты: эмодзи-семья из ZWJ занимает одиннадцать
 * и обрезалась посередине, оставляя вместо значка мусор. `Intl.Segmenter` есть во
 * всех живых браузерах, но в старом вебвью его может не быть — тогда возвращаем как есть,
 * длину всё равно проверит бэк.
 */
export function clampGraphemes(value: string, max: number): string {
  const trimmed = value.trim();
  const Segmenter = (Intl as { Segmenter?: typeof Intl.Segmenter }).Segmenter;
  if (!Segmenter) return trimmed;
  const parts = Array.from(new Segmenter(undefined, { granularity: 'grapheme' }).segment(trimmed));
  return parts.slice(0, max).map((p) => p.segment).join('');
}
